"use client";

import { useQueryStates } from "nuqs";
import { useCallback } from "react";

import { filterParsers } from "./filterParsers";
import { useCatalogSettings } from "./useCatalogSettings.hook";

export { filterParsers } from "./filterParsers";
export type { FilterParamKey } from "./filterParsers";

export function useFilterParams() {
  const [params, setParams] = useQueryStates(filterParsers);
  const [, setSettings] = useCatalogSettings();

  const setParamsWithReset = useCallback(
    (...args: Parameters<typeof setParams>) => {
      setSettings({ page: 1 });
      return setParams(...args);
    },
    [setParams, setSettings],
  );

  return [params, setParamsWithReset] as const;
}
